module.exports = __webpack_public_path__ + "dashboard/img/checkbox_on.bb5a2b825e3f360b75616c7b4018dfa3.svg";